import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { ModalBody, Modal } from "reactstrap";
import fixNumbers from "../../base/utils/fix_Numbers";
import Lable from "../../base/features/micro/Lable";
import { apiService } from "../../base/service/service";
import Swal from "sweetalert2";

function LoginModal({ acceptModal, acceptModalChange }) {
  const [authConfirmMode, setAuthConfirmMode] = useState(false);
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [login_expire_time, setLoginExpireTime] = useState(null);
  const [pending, setPending] = useState(null);

  useEffect(() => {
    if (login_expire_time) {
      const interval = setInterval(() => {
        setLoginExpireTime((time) => time - 1);
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [login_expire_time]);

  function auth() {
    setPending(true);
    apiService({
      url: `api/user/login`,
      methodType: "get",
      params: {
        phone: phone,
        city: "tabriz",
      },
    }).then((data) => {
      setPending(false);
      if (data?.success === 1) {
        setAuthConfirmMode(true);
        document.getElementById("code")?.focus();
        setLoginExpireTime(120);
      }
    });
  }
  function authConfirm() {
    setPending(true);
    let params = {
      client_secret: "WCRQutwCKMyj5okZR94aARc0IgO3mC6NEt2MekXu",
      grant_type: "password",
      client_id: 4,
      user_type: "user",
      username: phone,
      password: code,
    };
    apiService({ url: `oauth/token`, methodType: "post", body: params }).then(
      (data) => {
        if (data) {
          if (data && data.access_token) {
            localStorage.setItem(
              `token`,
              data.token_type + " " + data.access_token
            );
            setAuthConfirmMode(false);
            Swal.fire({
              icon: "success",
              text: "ورود شما با موفقیت انجام شد",
              confirmButtonText: "ادامه",
            }).then(({ isConfirmed }) => {
              if (isConfirmed) {
                window.history.back();
              }
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "کد وارد شده اشتباه است",
              confirmButtonText: "تایید",
              timer: 3000,
            });
          }
        }
        setPending(false);
      }
    );
  }
  return (
    <div>
      <Modal
        dir="rtl"
        zIndex="999"
        className="m-0"
        contentClassName="border-0 position-fixed fixed-bottom w-auto max-h-75 bg-none"
        isOpen={acceptModal}
        toggle={() => acceptModalChange(false)}
      >
        <ModalBody className="row mx-0 p-4 bg-light">
          <div className="text-center">
            <img
              alt="logo"
              width="150"
              className="my-4"
              src={
                require("../../base/assets/images/iran-app-logo.svg").default
              }
            />
            <p className="fw-bold">ورود با شماره موبایل</p>
            <p className="w-75 fs-7 d-inline-block text-secondary">
              لطفا شماره همراه خود را برای دریافت کد یکبار مصرف وارد کنید
            </p>
          </div>
          {authConfirmMode ? (
            <>
              <div className="p-3">
                <p className="fs-7 d-inline-block text-secondary text-center">
                  {`لطفا کد ورود یکبار مصرف ارسال شده به شماره ${phone} را وارد کنید`}
                </p>
                <p className="fs-2 fw-bolder text-center">
                  {login_expire_time === 0 ? (
                    <button
                      className="btn fs-7 fw-bolder text-main"
                      onClick={() => auth()}
                    >
                      ارسال دوباره کد
                    </button>
                  ) : (
                    ~~(login_expire_time / 60) +
                    ":" +
                    (login_expire_time % 60 < 10
                      ? "0" + (login_expire_time % 60)
                      : login_expire_time % 60)
                  )}
                </p>
                <div className="position-relative mt-2">
                  <input
                    dir="ltr"
                    id="code"
                    className="form-control rounded14 fs-2 px-3 py-2-3 text-center bg-light"
                    placeholder="-   -   -   -   -"
                    type="tel"
                    maxLength="5"
                    value={code}
                    onChange={(e) =>
                      /^[0-9]*$/.test(fixNumbers(e.target.value)) &&
                      setCode(fixNumbers(e.target.value))
                    }
                    onKeyDown={(e) =>
                      e.keyCode === 13 &&
                      document.getElementById("login-btn").click()
                    }
                    autoComplete={false}
                  />
                  {code && <Lable class="bg-light" text="کد ورود یکبار مصرف" />}
                </div>
                <div className="text-center">
                  <button
                    onClick={() => setAuthConfirmMode(false)}
                    className="btn small mt-2 text-center"
                  >
                    بازگشت
                  </button>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="col-12 px-0 position-relative mb-3">
                <input
                  id="phone"
                  className={`form-control bg-light mx-auto text-center px-3 py-2-3 rounded-3 ${
                    phone && "fw-bolder"
                  }`}
                  placeholder="تلفن همراه*(اجباری)"
                  dir="ltr"
                  autoComplete={false}
                  autoFocus={true}
                  value={phone}
                  onChange={(e) =>
                    /^[0-9]*$/.test(fixNumbers(e.target.value)) &&
                    setPhone(fixNumbers(e.target.value))
                  }
                  onKeyDown={(e) =>
                    e.keyCode === 13 &&
                    document.getElementById("login-btn").click()
                  }
                  type="tel"
                  maxLength="11"
                />
                {phone && (
                  <Lable class={"bg-light"} text="تلفن همراه*(اجباری)" />
                )}
              </div>
            </>
          )}
          <div className="col-6 px-1">
            <button
              id="login-btn"
              className="btn bg-main rounded7 text-white w-100"
              onClick={() => (authConfirmMode ? authConfirm() : auth())}
              disabled={
                authConfirmMode
                  ? code.length !== 5 || pending
                  : phone.length !== 11 || pending
              }
            >
              {pending ? (
                <Spinner
                  className="align-middle"
                  animation="border"
                  size="sm"
                />
              ) : (
                "تایید"
              )}
            </button>
          </div>
          <div className="col-6 px-1">
            <button
              className="btn w-100 text-danger"
              onClick={() => window.history.back()}
            >
              انصراف
            </button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default LoginModal;
